import {
  getLoanPurpose,
} from './Invoke';

export class ProductSearchInput {
  constructor(
    occupancyInput,
    propertyTypeInput,
    numberOfUnitsInput,
    countyInput,
    salesPriceInput,
    appraisedValueInput,
    userCreditInput,
    baseLoanAmountInput,
    loanTypeInput,
    amortizationTypesInput,
    cashRequestedInput = 0,
    loanPurposeOverride = null,
  ) {
    const loanPurposeInput = getLoanPurpose(loanTypeInput);
    let purpose = loanPurposeInput;

    if (loanPurposeOverride) {
      purpose = loanPurposeOverride;
    } else if (loanPurposeInput === 'RefiCashout') {
      purpose = cashRequestedInput > 0 ? loanPurposeInput : 'RefiRateTermLimitedCO';
    }

    this.borrowerInformation = {
      citizenship: 'USCitizen',
      waiveEscrows: false,
      monthsReserves: 24,
    };

    if (loanTypeInput === 'VA') {
      this.borrowerInformation.typeOfVeteran = 'ActiveDuty';
      this.borrowerInformation.vaFirstTimeUse = true;
    }
    this.propertyInformation = {
      occupancy: occupancyInput,
      county: countyInput,
      propertyType: propertyTypeInput,
      salesPrice: salesPriceInput, // FOLLOW UP OriginalLoanAmount?
      appraisedValue: appraisedValueInput, // from currentLoanAssumption estimatedHomeValue
      state: 'CO',
      corporateRelocation: false,
      numberOfStories: 1,
      numberOfUnits: numberOfUnitsInput,
    };
    this.loanInformation = {
      representativeFICO: userCreditInput,
      loanPurpose: purpose, // only use this for now
      loanType: loanTypeInput,
      baseLoanAmount: baseLoanAmountInput,
      loanTerms: ['ThirtyYear', 'TwentyYear', 'FifteenYear'],
      desiredLockPeriod: 45, // hardcoded to be always 45, confirmed with Ben
      lienType: 'First',
      amortizationTypes: amortizationTypesInput ?? ['Fixed', 'ARM'],
      armFixedTerms: ['ThreeYear', 'FiveYear', 'SevenYear', 'TenYear'],
      automatedUnderwritingSystem: 'NotSpecified',
      borrowerPaidMI: 'Yes',
      buydown: 'None',
      cashOutAmount: cashRequestedInput,
      desiredRate: 0,
      feesIn: 'No',
      expandedApprovalLevel: 'NotApplicable',
      interestOnly: false,
      secondLienAmount: 0,
      helocDrawnAmount: 0,
      helocLineAmount: 0,
      prepaymentPenalty: 'None',
      exemptFromVAFundingFee: loanTypeInput === 'VA',
      includeLOCompensationInPricing: 'YesLenderPaid',
      calculateTotalLoanAmount: true,
      assetDepletion: 'No',
      autoDebit: 'No',
      employeeLoan: 'No',
      communityAffordableSecond: 'No',
      reducedMI: false,
      loanLevelDebtToIncomeRatio: 43,
      customerInternalId: 'OBSearch',
      totalMonthlyQualifyingIncome: 20000, // in the future, we might want to calculate this based on user input but for now we will hardcode it.
    };
  }
}
